import moment from 'moment';

// Utility function to format a date using moment.js
export const formatDate = (date, format) => {
  if (!date) return ''; // Handle empty dates if needed
  if (!format)
    format = 'DD/MM/YYYY' // TODO: move default format to env file 
  return moment(date).format(format);
};

export default formatDate;

export const formatUTCtoLocalDate = (date, format) => {
  if (!date) return '';
  if (!format)
    format = 'DD/MM/YYYY';
  return moment.utc(date).local().format(format);
};

export function formatDateToISO(date) {
  if (!date) return '';
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero if needed
    const hours = ('0' + date.getHours()).slice(-2); // Add leading zero if needed
    const minutes = ('0' + date.getMinutes()).slice(-2); // Add leading zero if needed
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}